import React from 'react'
import { useAuth } from '../Hooks/useAuth'
import { Navigate } from 'react-router-dom'

const ProtectedRoutes = ({ children }) => {
    const { user } = useAuth()
    // If user is not authenticated, redirect to login page
    if (!user) return <Navigate to="/" />
  
    return children
}
export default ProtectedRoutes